import { TreeNodeType } from '../../../../lib/types/types';

export const constructHierarchyArray = (input: string, treeStructure?: TreeNodeType[]): string[] => {
	if (input && input.includes('.')) {
		const segments = input.split('.');
		const hierarchyArray: string[] = [];

		let currentSegment = '';

		for (const segment of segments) {
			currentSegment = currentSegment ? `${currentSegment}.${segment}` : segment;
			hierarchyArray.push(currentSegment);
		}

		return hierarchyArray;
	} else {
		const treeElement = treeStructure?.find((ele) => ele.id === input);
		if (treeElement?.children) {
			return [input, treeElement.children[0].id];
		}
		return [input];
	}
};
interface Node {
	id: string;
	label: string;
	content: React.ReactElement;
	children?: Node[];
}
export const extractIds = (data: Node[]): string[] => {
	const ids: string[] = [];

	function traverse(nodes: Node[]) {
		for (const node of nodes) {
			ids.push(node.id);
			if (node.children) {
				ids.pop();
				traverse(node.children);
			}
		}
	}

	traverse(data);
	return ids;
};
